module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Manage"
    }
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Manage")]), _vm._v(" "), (_vm.isGroupAdmin) ? _c('OrgManage') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-desktop"
  }, [_c('section', {
    staticClass: "column is-two-thirds is-offset-2"
  }, [_c('div', {
    staticClass: "flex-space-between"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Groups")]), _vm._v(" "), _c('section', [_c('input', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button",
      "name": "Add Team",
      "value": "+ Add Group"
    },
    on: {
      "click": function($event) {
        _vm.showGetUserInput = true
      }
    }
  })])]), _vm._v(" "), (_vm.teams.length > 0 && !_vm.loading) ? _c('ul', _vm._l((_vm.teams), function(team) {
    return _c('li', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex-space-between"
    }, [_c('div', {
      staticClass: "flex-align-center"
    }, [(_vm.is_admin) ? _c('span', {
      staticClass: "tag is-info user-count"
    }, [_vm._v(_vm._s(team.group.name))]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "title is-3",
      attrs: {
        "to": '/groups/' + team.id
      }
    }, [_vm._v(_vm._s(team.name))]), _vm._v(" "), _c('span', {
      staticClass: "tag is-medium"
    }, [_vm._v(_vm._s(team.privacy_setting == 'public' ? 'open' : team.privacy_setting))]), _vm._v(" "), _c('span', {
      staticClass: "tag is-medium user-count"
    }, [_vm._v(_vm._s(team.members.length) + " members")])], 1), _vm._v(" "), _c('input', {
      staticClass: "button",
      class: {
        'is-active': team.expanded
      },
      attrs: {
        "type": "button",
        "value": team.expanded ? 'collapse' : 'expand'
      },
      on: {
        "click": function($event) {
          _vm.toggleTeam(team.id)
        }
      }
    })]), _vm._v(" "), _c('section', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (team.expanded),
        expression: "team.expanded"
      }]
    }, [_c('section', {
      staticClass: "columns"
    }, [(_vm.editing) ? _c('GroupUserSearch', {
      attrs: {
        "team": team
      }
    }) : _vm._e(), _vm._v(" "), _c('TeamMemberList', {
      attrs: {
        "editing": _vm.editing,
        "team": team
      },
      on: {
        "editing": function($event) {
          _vm.editing = !_vm.editing
        }
      }
    })], 1), _vm._v(" "), (team.members.length == 0) ? _c('input', {
      staticClass: "button is-danger",
      attrs: {
        "type": "button",
        "name": "Delete Team",
        "value": "Delete Team"
      },
      on: {
        "click": function($event) {
          _vm.deleteTeam(team.id)
        }
      }
    }) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), (_vm.teams.length === 0 && !_vm.loading) ? _c('p', [_vm._v("No teams.")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('Loader') : _vm._e()], 1), _vm._v(" "), _c('Confirm', {
    attrs: {
      "title": "Deleting Team",
      "message": "Are you sure you want to delete this team?",
      "show": _vm.showDelete,
      "loading": _vm.deleting
    },
    on: {
      "cancel": function($event) {
        _vm.showDelete = false
      },
      "confirm": _vm.removeActiveTeam
    }
  }), _vm._v(" "), _c('GetUserInput', {
    attrs: {
      "title": "Create New Team",
      "message": "What should this team be called?",
      "show": _vm.showGetUserInput,
      "loading": _vm.deleting
    },
    on: {
      "cancel": function($event) {
        _vm.showGetUserInput = false
      },
      "confirm": _vm.addTeam
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-70e4f9a7"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Manage.vue
// module id = 1065
// module chunks = 0